/**
 * Cuántos puntos hacia atrás se miran como mucho. Una lectura mala suelta es
 * uno o dos puntos; más atrás ya no es «dónde está ahora».
 */
export const WALK_BACK_MAX_POINTS = 10;

/** Qué pasó al probar un punto: relleno, no cae en ninguna vía, o parar. */
export type WalkBackOutcome = 'done' | 'no-pk' | 'stop';

/**
 * Recorre el rastro desde el FINAL hasta el primer punto que sirva
 * (2026-09-29).
 *
 * El prellenado del cierre usaba solo el último punto. Con el usuario, en
 * QA-3, ese punto era una lectura suelta a 60 km —la ubicación real que Chrome
 * coló al recargar— con seis puntos buenos en la C-25z justo antes: el PK se
 * quedaba vacío y, sin reconocer el ramal, el 236+500 tecleado a mano se
 * rechazaba. En carretera pasa igual con una lectura mala al salir de un
 * túnel.
 *
 * `attempt` decide: `'done'` (ya está), `'no-pk'` (este no cae en ninguna vía:
 * probar el anterior) o `'stop'` (cancelado, o el sensor contestó y manda él).
 */
export async function walkBackTrack<P>(
  points: readonly P[],
  attempt: (point: P) => Promise<WalkBackOutcome>,
  maxPoints: number = WALK_BACK_MAX_POINTS
): Promise<void> {
  const last = points.length - 1;
  for (let i = last; i >= 0 && last - i < maxPoints; i -= 1) {
    if ((await attempt(points[i])) !== 'no-pk') return;
  }
}
